module.exports = "/build/web/svg/icon-phone--blue.f751b5507ca5afe998f392f08f5da9b5.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-phone--blue.svg
// module id = 112
// module chunks = 13